/* eslint-disable react/jsx-props-no-spreading */
import { useState } from "react";
import { IconEye, IconTrash, IconX } from "@tabler/icons-react";

import Notification, { NotificationProps } from "../Notification";
import IconNotifications from "../../Icon/IconNotifications";

interface NotificationDrawerProps {
  title: string;
  emptyLabel: string;
  readLabel: string;
  deleteLabel: string;
  notifications: NotificationProps[];
  onRead: () => void;
  onDelete: () => void;
  show?: boolean;
}

const NotificationDrawer = ({
  title, emptyLabel, readLabel, deleteLabel, notifications, onRead, onDelete, show = true,
}: NotificationDrawerProps) => {
  const [showDrawer, setShowDrawer] = useState(show);
  return showDrawer ? (
    <div className="h-[687px] w-[374px] md:w-[600px] bg-bg-subtle border border-border-base text-text-base rounded-xl shadow-xl">
      <div className="flex justify-between py-6 px-4">
        <span className="typography-large-strong">{title}</span>
        <IconX className="cursor-pointer" onClick={() => setShowDrawer(false)} />
      </div>
      <div className="h-[563px] w-full bg-bg-base overflow-x-hidden overflow-auto border-y">
        {notifications?.length > 0
          ? <div>{notifications.map((n) => <div className="border-b"><Notification {...n} /></div>)}</div>
          : (
            <div className="flex flex-col h-full justify-center items-center text-center gap-4 md:gap-8 px-10 md:px-20">
              <IconNotifications height={221} width={172.25} />
              <span className="typography-medium-base">{emptyLabel}</span>
            </div>
          )}
      </div>
      <div className="flex justify-between p-4 typography-medium-base text-text-interactive-base">
        {notifications?.length > 0 && (
          <button className="flex items-center gap-1" type="button" onClick={() => onRead()}>
            <IconEye className="text-icon-interactive" />
            <span>{readLabel}</span>
          </button>
        )}
        {notifications?.length > 0 && (
          <button className="flex items-center gap-1" type="button" onClick={() => onDelete()}>
            <IconTrash className="text-icon-interactive" />
            <span>{deleteLabel}</span>
          </button>
        )}
      </div>
    </div>
  ) : <></>;
};

export default NotificationDrawer;
